import axios from 'axios';
import { RequestError } from './';

const client = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    withCredentials: true, // automatically send saved cookie
    headers: {
        'x-bdes-api-key': 'piSb1hNiLSxIBz0WrxudRXucyVf6seUpiSb1L9NTYFiFECuwDJ111',
    },
});

client.interceptors.response.use(
    (response) => response.data,
    (error) => {
        const formattedError: RequestError = {
            status: 0,
            message: '',
        };
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
            formattedError.status = error.response.status;
            formattedError.data = error.response.data;
            formattedError.headers = error.response.headers;
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest
            // console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            // console.log('Error', error.message);
        }

        throw formattedError;
    },
);

export default client;
